import { Card, type SxProps, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

interface Props {
  message: string | JSX.Element
  sx?: SxProps
}

export const WarningCard = (props: Props): JSX.Element => {
  return <Card sx={{ ...props.sx, backgroundColor: '#FDF0C1', border: '1px solid #F9DC72', p: '8px', display: 'flex', mt: '1em' }}>
    <InfoOutlinedIcon sx={{ alignSelf: 'center' }} />
    <Typography variant='body1' sx={{ ml: '.5em' }}>
      {props.message}
    </Typography>
  </Card>
}
